import clsx from "clsx";

type Props = {
  isApply?: boolean;
  label: string;
  description: string;
  onClick: () => void;
};

export default function NotificationsOfferButton({ isApply, label, description, onClick }: Props) {
  return (
    <button
      type="button"
      className="w-[7.375rem] border-2 rounded-xl cursor-pointer border-dark-900/50"
      onClick={onClick}
    >
      <div
        className={clsx(
          "relative w-full h-full to-white/3 bg-gradient-to-r rounded-lg",
          isApply ? "from-[#5FFF69]/10" : "from-[#D73434]/10",
        )}
      >
        <div
          className={clsx(
            "absolute top-0 left-0 size-full rounded-lg opacity-0 hover:opacity-100 transition-opacity duration-200",
            isApply
              ? "[background-image:linear-gradient(to_right,#5fff691a,#5fff691a),linear-gradient(to_right,#5fff691a,#FFFFFF08)]"
              : "[background-image:linear-gradient(to_right,#d734341a,#d734341a),linear-gradient(to_right,#d734341a,#FFFFFF08)]",
          )}
        />
        <div className="relative z-1 flex items-center p-1 pointer-events-none">
          <div
            className={clsx(
              "flex justify-center items-center w-[1.625rem] aspect-square font-bold text-13 text-dark-900 rounded-lg",
              "shrink-0",
              isApply ? "bg-[#5FFF69]" : "bg-[#FF4E4E]",
            )}
          >
            {label}
          </div>
          <p className="m-auto font-bold text-10 uppercase">{description}</p>
        </div>
      </div>
    </button>
  );
}
